export default __webpack_public_path__ + "static/visa-5e0d7e7bcf33762dc51c9d547f24f8cf.jpg";